/*
 * Project: BookingEngine
 * Module: components/common/ShareWithOthers.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DsModal from '../ds/molecules/DsModal';

import ShareEmailSuccess from './ShareEmailSuccess';
import ShareEmail from './ShareEmail';
import ShareCopyLink from './ShareCopyLink';
import ShareBtn from '../ds/molecules/btn/ShareBtn';
import { sendGTMEvents } from '../../actions/Booking';
import { store } from '../../Store';

class ShareWithOthers extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getResetState();
  }

  getResetState() {
    return {
      showShareModal: false,
      showShareSuccess: false,
      shareURL: '',
      emailList: [],
    };
  }

  setDefaultState() {
    // NOTE Reset all the state but keep the modal shown with the same URL
    this.setState({ ...this.getResetState(), showShareModal: true, shareURL: this.state.shareURL });
  }

  openEmailShareModal() {
    this.props.sendGTMEvents([{ event: 'ShareLink' }]);
    this.props.buildUrl().then((url) => {
      if (!this.state.showShareModal) {
        this.setState({ showShareModal: true, shareURL: url });
      }
    });
  }

  onShareModalClose = (buttonId) => {
    switch (buttonId) {
      case 'done':
        this.props.sendGTMEvents([{ event: 'ShareLink-Done' }]);
        this.setState(this.getResetState());
        break;
      case 'back': // "share with others option" --> still show modal where emails can be added
        this.setDefaultState();
        break;
      default:
        this.props.sendGTMEvents([{ event: 'ShareLink-Close' }]);
        this.setState(this.getResetState());
        break;
    }
  };

  onSendEmails(emailList) {
    const sentEmailList = async () => { this.props.onShare(this.state.shareURL, emailList); };
    sentEmailList().then(() => {
      this.props.sendGTMEvents([{ event: 'ShareLink-Send' }]);
      this.setState({ showShareSuccess: true, emailList, shared: true });
    });
  }

  renderShareDescription() {
    if (!this.props.renderDescription) {
      return null;
    }
    return this.props.renderDescription();
  }

  renderCopyOptions() {
    return this.props.shareTypes.map((shareType) => {
      switch (shareType) {
        case 'copy-link':
          return <ShareCopyLink
            key='share-copy-link'
            url={ this.state.shareURL }
            setShared={ (isShared) => this.setShared(isShared) }
          />;
        case 'email':
          return <ShareEmail
            key='share-email'
            onSendEmails={ (emailList) => this.onSendEmails(emailList) }
          />;
        default:
          // Adding more types here when they are defined. Remember to add the "key" attribute!
          return null;
      }
    });
  }

  setShared(isShared) {
    this.setState({ shared: isShared });
  }

  renderShareOptionsForm() {
    return (
      <div className="share-others-modal p-4">
        <div className="share-options mr-2">
          <header className="share-header">
            <div className="share-header__title">
              {this.context.t('share with others')}
            </div>
          </header>
          {this.renderCopyOptions()}
        </div>
        {this.renderShareDescription() || this.props.children}
      </div>
    );
  }

  renderSuccessModal() {
    return (
      <ShareEmailSuccess
        sharedEmails={this.state.emailList}
        onClose={this.onShareModalClose}
      />
    );
  }

  render() {
    const { showShareSuccess, showShareModal } = this.state;
    const { className } = this.props;
    const label = this.context.t('share with others');
    const stateForAgentCode = store.getState();
    const agentCodeEnteredInBookingForm = stateForAgentCode.booking.agentCode;
    const agentSellEnteredInBookingForm = stateForAgentCode.booking.agentSell;
    if (agentCodeEnteredInBookingForm !== '' && agentSellEnteredInBookingForm === 'false') {
      // Si es un agente y no va a vender a otros clientes, no se habilitará el botón de compartir link
      return null;
    }

    return (
      <React.Fragment>
        <ShareBtn icon="share" className={className} label={label} onClick={() => this.openEmailShareModal()}/>
        {showShareModal && <DsModal onClose={() => this.onShareModalClose()}>
          {showShareSuccess ? this.renderSuccessModal() : this.renderShareOptionsForm()}
        </DsModal>}
      </React.Fragment>
    );
  }
}

ShareWithOthers.propTypes = {
  buildUrl: PropTypes.func.isRequired,
  onShare: PropTypes.func.isRequired,
  renderDescription: PropTypes.func,
  shareTypes: PropTypes.arrayOf(PropTypes.string),
};

ShareWithOthers.defaultProps = {
  shareTypes: ['copy-link', 'email'],
};

ShareWithOthers.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  sendGTMEvents: (payload) => dispatch(sendGTMEvents(payload)),
});

export default connect(null, mapDispatchToProps)(ShareWithOthers);
